import { SetStateAction } from "react";

/** Useful when you are passed an onChange from useState and need an unambiguous T  */
export const unwrapSetStateAction = <T>(
  prevState: T,
  data: SetStateAction<T>,
): T => {
  if (data instanceof Function) {
    return data(prevState);
  }
  return data;
};

export const getKeyForReactNode = (node: React.ReactNode) => {
  if (node == null) return undefined;
  if (typeof node !== "object") return undefined;
  if (!("key" in node)) return undefined;
  return node.key;
};
